import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import Ring from 'src/Components/shared/Ring'
import { IconLock } from 'src/Components/shared/Icon'

import styles from './RingLock.module.scss'

const propTypes = {
  color: PropTypes.oneOf(['white', 'blue'])
}

const defaultProps = {
  color: 'white'
}

const RingLock = ({ className, color, ...restProps }) => (
  <Ring color={color} className={classnames(className, styles.ring)}>
    <IconLock color={color} className={styles.lock} />
  </Ring>
)

RingLock.propTypes = propTypes
RingLock.defaultProps = defaultProps

export default RingLock
